import { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"

/**
 * Component that redirects to external Terveystalo feedback page
 * when no valid route is matched.
 */
const FallbackRedirect = () => {
  const { lang } = useParams<{ lang: string }>()
  const { t } = useTranslation()

  useEffect(() => {
    // Get the fallback URL for the current language
    const fallbackUrl = t("routes.fallbackUrl")

    console.log(`[FallbackRedirect] Redirecting to: ${fallbackUrl}`)

    // Redirect to external URL
    window.location.href = fallbackUrl
  }, [lang, t])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div>Redirecting...</div>
    </div>
  )
}

export default FallbackRedirect
